import {BASE_TITLES, FILTER_KEYS} from '../../../shared/constants';

export const filterServiceRequestsBy: string[][] = [
  [BASE_TITLES.apartment.base, FILTER_KEYS.apartment],
  [BASE_TITLES.street.base, FILTER_KEYS.street],
  [BASE_TITLES.city.base, FILTER_KEYS.city],
  [BASE_TITLES.region.base, FILTER_KEYS.region],
  [BASE_TITLES.contractNumber.base, FILTER_KEYS.counter],
  [BASE_TITLES.house.base, FILTER_KEYS.house],
  [BASE_TITLES.deviceType.base, FILTER_KEYS.serviceType],
  [BASE_TITLES.requestStatus.base, FILTER_KEYS.status],
  [BASE_TITLES.taskLocation.base, FILTER_KEYS.taskLocationCode],
  [BASE_TITLES.workers.base, FILTER_KEYS.workerUid],
];
